import type { AnchorConfigProtocol } from '@lighthouse/core'
import { type FlowLayoutNode } from '@lighthouse/shared'
import React, { forwardRef, memo } from 'react'

import { ContainerLayoutWithPanel } from '../../components/ContainerLayoutWithPanel'
import { useEffectiveAnchorId } from '../../context'
import { useScrollToAnchorWhenHashMatch } from '../../hooks/useScrollToAnchorWhenHashMatch'

interface ContainerBlockProps extends React.ComponentPropsWithoutRef<'div'> {
    node: FlowLayoutNode
    shown?: boolean
    currentView?: string
    disabled?: boolean
    isPointer?: boolean
}

const ContainerBlock = memo(
    forwardRef<HTMLDivElement, ContainerBlockProps>(({ node, shown = true, currentView, ...rest }, ref) => {
        const anchor = (node.block?.config as { anchor?: AnchorConfigProtocol } | undefined)?.anchor
        const { anchorId } = anchor || {}
        const effectiveAnchorId = useEffectiveAnchorId(anchorId)
        useScrollToAnchorWhenHashMatch(effectiveAnchorId, anchor)

        if (!shown) {
            return null
        }

        return <ContainerLayoutWithPanel node={node} currentView={currentView} ref={ref} anchorId={effectiveAnchorId} {...rest} />
    })
)

ContainerBlock.displayName = 'ContainerBlock'

export default ContainerBlock
